module.exports = __webpack_public_path__ + "img/stock4.0d149d84.png";